import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react'
import {FormInput} from '../../01-Atoms/FormInput/FormInput'


/**
 * Primary UI component for user interaction
 */
export const AddressLookUp = ({ legend, loqateKey, names, showLookup, tracking, trackEvent, values, validationHash, ...props }) => {
  const [lookUpIsVisible, lookUpIsVisibleSet] = useState(showLookup)
  const [hasInitialised, hasInitialisedSet] = useState(false)
  const [searchValue, searchValueSet] = useState('')
  const fieldSetRef = useRef(null)
  const [addressInputEventFired, addressInputEventFiredSet] = useState(false)

  const control = new pca.Address([
    { element: "search", field: "" }
  ], { key: loqateKey, countries: { codesList: "GBR" } })

  control.listen("populate", (address, variations) => {
    selectAnAddressEvent()
    props.onInputChange(names.addressLine1, address['Line1'])
    props.onInputChange(names.addressLine2, address['Line2'])
    props.onInputChange(names.townCity, address['City'])
    props.onInputChange(names.postCode, address['PostalCode'])

    if (tracking && trackEvent) {
      trackEvent(tracking.id, `${tracking.name} address lookup populated`)
    }

    //Hide address lookup input when fields get populated
    lookUpIsVisibleSet(false)
  })

  const addressInputEvent = () => {
    if (window['dataLayer'] && !addressInputEventFired) {
      addressInputEventFiredSet(true) //only fire this event once
      let dataLayer = window['dataLayer']
      dataLayer.push({
        'event': 'address_search',
        'eventCategory': 'donation form',
        'eventAction': 'address lookup',
        'eventLabel': 'address search'
      })
    }
  }

  const selectAnAddressEvent = () => {
    if (window['dataLayer']) {
      let dataLayer = window['dataLayer']
      dataLayer.push({
        'event': 'add_address_info',
        'eventCategory': 'donation form',
        'eventAction': 'address lookup',
        'eventLabel': 'add address info'
      })
    }
  }

  const manualInputEvent = () => {
    if (window['dataLayer']) {
      let dataLayer = window['dataLayer']
      dataLayer.push({
        'event': 'address_manual_input',
        'eventCategory': 'donation form',
        'eventAction': 'address lookup',
        'eventLabel': 'address manual input'
      })
    }
  }

  useEffect(() => {
    if (hasInitialised) {

      if (values.addressLine1 === '' || values.townCity === '' || names.postCode === '') {
        lookUpIsVisibleSet(null)
      }
    }
  }, [values.addressLine1, values.townCity, names.postCode])

  useEffect(() => {
    if (hasInitialised) {
      if (values.addressLine1 === '' || values.townCity === '' || names.postCode === '') {
        lookUpIsVisibleSet(false)
      }
    }
    else {
      hasInitialisedSet(true)
    }

  }, [validationHash])

  useEffect(() => {
    if (hasInitialised && fieldSetRef.current) {
      const button = fieldSetRef.current.querySelector('input')

      if (button) {
        button.focus()
      }
    }
  }, [lookUpIsVisible])

  return (
    <div className={'b-form-row'}>
      <div className={'o-address-lookup'} ref={fieldSetRef} aria-live={'polite'}>
        {lookUpIsVisible ?
          <fieldset className={'b-form-fieldset  b-form-fieldset--with-border'}>
            {legend && <legend>{legend}</legend>}

            <div className={'b-form-row'}>
              <div className="b-form-input" data-type={'text'} data-state={'ok'}>
                <label htmlFor={'search'}>Look up the address</label>

                <input
                  key={'lookup'}
                  id={'search'}
                  name={'search'}
                  type={'text'}
                  value={searchValue} 
                  onChange={event => {searchValueSet(event.target.value); addressInputEvent()}}
                  autoComplete={'off'}
                />
              </div>
            </div>

            <button className={'b-button-text-blue'} onClick={() => {lookUpIsVisibleSet(false); manualInputEvent()}}>Enter address manually</button>
          </fieldset> :
          <fieldset className='b-form-fieldset  b-form-fieldset--with-border'>
            {legend && <legend>{legend}</legend>}

            <FormInput
              label={'Address line 1'}
              value={values.addressLine1}
              required={true}
              name={names.addressLine1}
              type={'text'}
              onInputChange={props.onInputChange}
              validationHash={validationHash}
              validationMessages={
                [
                  { type: 'valueMissing', message: 'Please provide the first line of your address' },
                  { type: 'maxlength', maxlength: 30 }
                ]
              } />

            <FormInput
              label={'Address line 2'}
              value={values.addressLine2}
              required={false}
              name={names.addressLine2}
              type={'text'}
              onInputChange={props.onInputChange}
              validationHash={validationHash}
              validationMessages={
                [{ type: 'maxlength', maxlength: 30 }]
              }

            />

            <FormInput
              label={'Town / city'}
              value={values.townCity}
              required={true}
              name={names.townCity}
              type={'text'}
              onInputChange={props.onInputChange}
              validationHash={validationHash}
              validationMessages={
                [
                  { type: 'valueMissing', message: 'Please provide a town or city' },
                  { type: 'maxlength', maxlength: 30 }
                ]
              } />

            <FormInput
              label={'Postcode'}
              value={values.postCode}
              required={true}
              name={names.postCode}
              type={'text'}
              onInputChange={props.onInputChange}
              validationHash={validationHash}
              validationMessages={
                [
                  { type: 'valueMissing', message: 'Please provide a postcode' },
                  { type: 'maxlength', maxlength: 12 }
                ]
              } />

            <button className={'b-button-text-blue'} onClick={() => lookUpIsVisibleSet(true)}>Look up address</button>
          </fieldset>
        }
      </div>
    </div>
  )
}

AddressLookUp.propTypes = {
  showLookup: PropTypes.bool,
  legend: PropTypes.string,
  validationHash: PropTypes.string,
  loqateKey: PropTypes.string,
  onInputChange: PropTypes.func,
  names: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    townCity: PropTypes.string,
    postCode: PropTypes.string,
  }),
  tracking: PropTypes.shape({
    id  : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
  }),
  trackEvent: PropTypes.func,
  values: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    townCity: PropTypes.string,
    postCode: PropTypes.string,
  })
}
